import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText, Radio, Box, Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import WarningButton from '../buttons/WarningButton';
import TooltipHelpButton from '../buttons/TooltipHelpButton/TooltipHelpButton';

const styles = theme => ({
    addCreditsButton: {
        position: "absolute",
        top: "15px",
        right: " 16px"
    }
});

const ExportListItem = React.memo(({
    classes,
    videoType,
    selectedVideoType,
    onSelect,
    disabled,
    primary,
    secondary,
    warningText,
    resolutionWarning,
    helpText,
    showUpgradeButton,
    showCreditsButton,
    onUpgradeClick,
    onCreditsClick
}) => {
    const renderButton = () => {
        if (showCreditsButton) {
            return (
                <Button onClick={onCreditsClick}>
                    ADD CREDITS
                </Button>
            );
        }
        if (showUpgradeButton) {
            return (
                <Button onClick={onUpgradeClick}>
                    OPTIONS
                </Button>
            );
        }
        return null;
    };

    return (
        <>
            <ListItemButton
                disabled={disabled}
                onClick={onSelect}
                selected={selectedVideoType === videoType}
            >
                <ListItemIcon>
                    <Radio
                        checked={selectedVideoType === videoType}
                        color='primary'
                        tabIndex='-1'
                    />
                </ListItemIcon>
                <ListItemText
                    primary={
                        <>
                            {primary}
                            {warningText && <WarningButton title={warningText} />}
                            {resolutionWarning && <WarningButton title={resolutionWarning} />}
                            {helpText && <TooltipHelpButton title={helpText} />}
                        </>
                    }
                    secondary={secondary}
                />
            </ListItemButton>
            {(showUpgradeButton || showCreditsButton) && (
                <Box className={classes.addCreditsButton}>
                    {renderButton()}
                </Box>
            )}
        </>
    );
});

export default withStyles(ExportListItem, styles);